import { useEffect, useState } from 'react';
import { checkAppIsExpired } from './useAppIsExpired.utils';

export const useAppIsExpired = (): boolean => {
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    checkAppIsExpired().then((appIsExpired) => setIsExpired(appIsExpired));
  }, []);

  return isExpired;
};
